












import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

import { Action, Getter } from 'vuex-class';
import { OrganisationState, Organisation } from '@/types';
import { ProjectState, Project } from '@/types';
import { RouterHelper } from '../router';

@Component({
  components: {
  },
})

export default class Breadcrumb extends Vue {

  private items: any[] = [];

  private get routeName() {
    return this.$route.meta.friendlyName || this.$route.name!;
  }

  @Getter private activeOrganisation: any;
  @Getter private activeProject: any;
  @Getter private activeProjectId: any;

  private async created() {
    this.items.push({
      text: this.activeOrganisation[0].name,
      disabled: false,
    });
    if (this.activeProjectId) {
      this.items.push({
        text: 'Projects',
        disabled: false,
      });
      this.items.push({
        text: this.activeProject[0].name,
        disabled: false,
      });
    }
    this.items.push({
      text: this.routeName,
      disabled: false,
    });
  }
}
